enum ReservationStatus {
  Pending = 'pending',
  Cancelled = 'cancelled',
  Completed = 'completed',
}

export default ReservationStatus;
